// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__29BIa","options":"AnswerScale_options__uu0xR","selected":"AnswerScale_selected__2zYOZ"};